import { createContextWithHook } from '@chilipiper/utils'
import { ModalFlowContextActions, ModalFlowContextStateData } from '../types'

export type PromiseResolutionMethods = {
  reject?: (value: unknown) => void
  resolve?: (value: unknown) => void
}

export type ModalFlowContextState = ModalFlowContextStateData &
  PromiseResolutionMethods &
  ModalFlowContextActions

export const { ModalFlowBaseProvider, useModalFlowContext } =
  createContextWithHook<ModalFlowContextState>()('ModalFlow')
